import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69717b5b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin":"12px 0","display":"flex","padding":"0 9px"} }
const _hoisted_2 = ["onMouseenter"]

import { ref, watch, reactive } from 'vue';
import ContextMenu from '@imengyu/vue3-context-menu';
import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css';
import { useRoute, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'Tabbar',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const editableTabsValue = ref(route.fullPath);

let editableTabs = ref(JSON.parse(localStorage.getItem('editableTabs')) || []);

const choseItem = ref(null);

const enterGiveValue = (item: any) => {
  choseItem.value = item;
};
const cleanTabs = () => {
  let item = choseItem?.value;
  editableTabsValue.value = item.path;
  editableTabs.value = [];
  editableTabs.value.push(item);
  localStorage.setItem('editableTabs', JSON.stringify(editableTabs.value));

  if (item.path == route.fullPath) {
    updateTabs();
  } else {
    router.push(item.path);
  }
};
//删除更新tabs并跳转
const handleTabsEdit = (targetName, action) => {
  if (action === 'remove') {
    if (editableTabs.value.length === 1) {
      editableTabsValue.value = editableTabs.value[1].path;
      return;
    }
    editableTabs.value.forEach((item, i) => {
      if (item.name === targetName) {
        if (i === 0) {
          router.push(editableTabs.value[1].path);
          editableTabsValue.value = editableTabs.value[1].path;
        } else {
          router.push(editableTabs.value[i - 1].path);
          editableTabsValue.value = editableTabs.value[i - 1].path;
        }
        editableTabs.value.splice(i, 1);
        localStorage.setItem(
          'editableTabs',
          JSON.stringify(editableTabs.value)
        );
      }
    });
  }
};
//更新tabs
const updateTabs = () => {
  editableTabs.value = JSON.parse(localStorage.getItem('editableTabs')) || [];
  let obj = {
    title: route.meta.title,
    name: route.fullPath,
    path: route.fullPath,
  };

  editableTabsValue.value = route.fullPath;
  let arr = editableTabs.value.filter((item) => item.title === obj.title);
  if (arr.length <= 0) {
    editableTabs.value.push(obj);
  }
  localStorage.setItem('editableTabs', JSON.stringify(editableTabs.value));
};
//跳转到指定tabs
const goPath = (item) => {
  router.push(item);
  editableTabsValue.value = item;
};
const onContextMenu = (e: MouseEvent) => {
  //prevent the browser's default menu
  e.preventDefault();
  //show your menu
  ContextMenu.showContextMenu({
    x: e.x,
    y: e.y,
    items: [
      {
        label: '清空其他选项',
        onClick: () => cleanTabs(),
      },
    ],
  });
};
watch(route, () => {
  updateTabs();
});

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_tabs, {
        activeKey: editableTabsValue.value,
        "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((editableTabsValue).value = $event)),
        type: "editable-card",
        hideAdd: "",
        onEdit: handleTabsEdit,
        onTabClick: goPath
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editableTabs), (item, index) => {
            return (_openBlock(), _createBlock(_component_a_tab_pane, {
              key: item.name,
              name: item.name,
              closable: true
            }, {
              tab: _withCtx(() => [
                _createElementVNode("div", {
                  onContextmenu: _cache[0] || (_cache[0] = ($event: any) => (onContextMenu($event))),
                  onMouseenter: ($event: any) => (enterGiveValue(item))
                }, _toDisplayString(item.title), 41, _hoisted_2)
              ]),
              _: 2
            }, 1032, ["name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["activeKey"])
    ])
  ]))
}
}

})